import React from 'react';

export default class ServicePartPanelHeader extends React.Component {

    getPartFromId(id) {
        for (let i = 0; i < this.props.parts.length; i++) {
            const part = this.props.parts[i];
            if (part.id === id) {
                return part;
            }
        }
    }

    renderSelectedPartsLabel() {
        let selectedPartLabel;

        selectedPartLabel = this.props.selectedPartIds.map((id) => {
            const part = this.getPartFromId(id);
            const price = part.price_cents > 0 ?
                <span>(+&nbsp;{parseFloat(part.price_cents / 100.0).toFixed(2)}&nbsp;€)</span> : '';

            return <li key={part.id}>{part.name}&nbsp;{price}</li>;
        });

        return <ul className="selected-parts">{selectedPartLabel}</ul>
    }

    renderChooseLabel() {
        let chooseLabel;

        if (this.props.min > 0) {
            if (this.props.max === 0) {
                chooseLabel = I18n.t('service_ordering.choose_at_least', {number: this.props.min});
            } else if (this.props.min === this.props.max) {
                chooseLabel = I18n.t('service_ordering.choose', {number: this.props.min});
            } else {
                chooseLabel = I18n.t('service_ordering.choose_between', {min: this.props.min, max: this.props.max});
            }
        }
        else if (this.props.min == 0 && this.props.max == 0) {
            chooseLabel = I18n.t('service_ordering.optional');
        }
        else if (this.props.min == 0 && this.props.max != 0) {
            chooseLabel = I18n.t('service_ordering.optional_under', {max: this.props.max});
        }

        return <div className="choose-help">{chooseLabel}</div>;
    }

    renderRightPart() {
        let rightLabel;

        if (!this.props.expanded && (this.props.selectedPartIds.length > 0)) {
            rightLabel = this.renderSelectedPartsLabel();
        } else {
            rightLabel = this.renderChooseLabel();
        }

        return <div>{rightLabel}</div>;
    }

    render() {
        const icon = this.props.expanded ? 'fa-chevron-down' : 'fa-chevron-right';

        const link = <div href={'#' + (this.props.id || '')}
                          className={this.props.expanded ? null : 'expanded'}
                          onClick={this.props.handleSelect}>

            <div className="left">
                <i className={`fas ${icon}`}/> {' '}
                {this.props.name}
            </div>
            <div className="right">{this.renderRightPart()}</div>
            <div className="clearfix"/>
        </div>;

        return (
            <div>
                <div className="panel-title">
                    {link}
                </div>
            </div>
        );
    }
}
